import React from 'react';
import {
    createSelector
} from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import logo from 'dan-images/logo.png';
import colorfull from 'dan-api/palette/colorfull';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import classNames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';

import Fade from '@material-ui/core/Fade';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import DatePicker, { registerLocale } from 'react-datepicker';
import '../../SettingPage/datepicker.css';
import tr from 'date-fns/locale/tr';
import 'leaflet/dist/leaflet.css';
import cookie from 'react-cookies';
import Select from '@material-ui/core/Select';
import MapClusterReport from '../../SettingPage/ReportPage/Maps/MapClusterReport';
import {
    getReviews, setFranchiseReportReviewsFilter, setFranchiseReportBrandSelected, getEntegrationCacheList,
    filterReviewsDownload, setFranchiseReportReviewsUpdate
} from '../../../../redux/modules/centerbrand';
import {
    getPackageAdditionDetail
} from '../../../../redux/modules/addition';
import { getParameter } from '../../../../function/GeneralFunction';
registerLocale('tr', tr);
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import PackageAdditionDetail from '../../PackagePage/PackageAdditionDetail';
import Tooltip from '@material-ui/core/Tooltip';


const styles = theme => ({
    nested: {
        paddingLeft: theme.spacing(4),
    }
});

class Reviews extends React.Component {
    constructor() {
        super();
        this.state = { isComment : false }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.isReviewsUpdate == this.props.isReviewsUpdate) {
            return false;
        }
        return true;
    }

    async componentDidMount() {

    }

    handleChangeFilterReviews = name => event => {
        const { filterReviews } = this.props;
        filterReviews[name] = (name == "StartDatetime" || name == "EndDatetime" ? moment.utc(event, 'MM-DD-YYYY').local().format("YYYY-MM-DDTHH:mm") : event.target.value);
        if (name == "EntegrationId") {
            filterReviews.Type = event.currentTarget.getAttribute("data-type");
        }
        this.props.setFranchiseReportReviewsFilter(filterReviews).then(() => { });
    };

    handleChange = async (event) => {
        await this.props.setFranchiseReportBrandSelected(event.target.value).then(() => { });
        this.props.getEntegrationCacheList(event.target.value).then(() => { });
    };

    handleClickPopover = event => {
        this.props.getPackageAdditionDetail(event.currentTarget.id, event.currentTarget);
    };

    render() {
        const {
            franchiseReportName, filterReviews, isCenterReportLoading, classes, franchiseReportReviewsData,
            franchiseReportBrandSelected, centerBrandData, franchiseBrandEntegrationList
        } = this.props;

        if (franchiseReportName != 'ReviewsReport') {
            return null;
        }

        var entList = [];
        if (franchiseBrandEntegrationList != null) {
            franchiseBrandEntegrationList.GetirYemek.map((n, i) => {
                entList.push({ "Id": n.secretkey, "Name": "GetirYemek - " + n.name, "Type": "GetirYemek" });
            })
            franchiseBrandEntegrationList.TrendyolYemek.map((n, i) => {
                entList.push({ "Id": n.id, "Name": "TrendyolYemek - " + n.name, "Type": "TrendyolYemek" });
            })
        }

        var list = [];
        list = this.state.isComment ? franchiseReportReviewsData.filter(x=>x.comment.length > 0) : franchiseReportReviewsData;
        return (
            <Paper className={classes.root} elevation={0} style={{ height: '100%', borderRadius: 0, overflowX: 'hidden', overflowY: 'auto' }}>
                <PackageAdditionDetail classes={classes} />
                <div style={{
                    backgroundColor: '#424242', padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center'
                }}
                >
                    {"Yorum ve Puanlamalar"}
                </div>
                <Grid container spacing={1} style={{ padding: 10 }}>
                    <Grid item md={3}>
                        <Typography
                            style={{
                                marginBottom: 6, padding: 0, fontSize: 12, fontFamily: 'Quicksand,sans-serif', lineHeight: 1, textAlign: 'left'
                            }}
                            className={classes.flex}
                        >
                            {"Başlangıç Tarihi"}
                        </Typography>
                        <DatePicker
                            selected={new Date(filterReviews.StartDatetime)}
                            onChange={this.handleChangeFilterReviews('StartDatetime')}
                            dateFormat="dd.MM.yyyy HH:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeFormat="HH:mm"
                            locale="tr"
                            className="inputDate"
                        />
                    </Grid>
                    <Grid item md={3}>
                        <Typography
                            style={{
                                marginBottom: 6, padding: 0, fontSize: 12, fontFamily: 'Quicksand,sans-serif', lineHeight: 1, textAlign: 'left'
                            }}
                            className={classes.flex}
                        >
                            {"Bitiş Tarihi"}
                        </Typography>
                        <DatePicker
                            selected={new Date(filterReviews.EndDatetime)}
                            onChange={this.handleChangeFilterReviews('EndDatetime')}
                            dateFormat="dd.MM.yyyy HH:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeFormat="HH:mm"
                            locale="tr"
                            className="inputDate"
                        />
                    </Grid>
                    <Grid item md={2}>
                        <Typography
                            style={{
                                marginBottom: 6, padding: 0, fontSize: 12, fontFamily: 'Quicksand,sans-serif', lineHeight: 1, textAlign: 'left'
                            }}
                            className={classes.flex}
                        >
                            {"Şube Seçimi"}
                        </Typography>
                        <Select
                            fullWidth
                            labelId="demo-mutiple-checkbox-label"
                            id="demo-mutiple-checkbox"
                            style={{ height: 38 }}
                            value={franchiseReportBrandSelected}
                            onChange={this.handleChange}
                        >
                            {centerBrandData.map((n, i) => (
                                <MenuItem lat={n.Latitude} lng={n.Longitude} key={i} value={n.Id}>
                                    <ListItemText primary={n.Name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item md={2}>
                        <Typography
                            style={{
                                marginBottom: 6, padding: 0, fontSize: 12, fontFamily: 'Quicksand,sans-serif', lineHeight: 1, textAlign: 'left'
                            }}
                            className={classes.flex}
                        >
                            {"Entegrasyon Seçimi"}
                        </Typography>
                        <Select
                            fullWidth
                            labelId="demo-mutiple-checkbox-label"
                            id="demo-mutiple-checkbox"
                            style={{ height: 38 }}
                            value={filterReviews.EntegrationId}
                            onChange={this.handleChangeFilterReviews("EntegrationId")}
                        >
                            {entList.map((n, i) => (
                                <MenuItem key={i} value={n.Id} data-type={n.Type}>
                                    <ListItemText primary={n.Name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item md={2}>
                        <Button fullWidth disabled={isCenterReportLoading} onClick={() => this.props.getReviews().then(() => { })} style={{ marginTop: 18, borderRadius: 5, height: 37, padding: '6px 24px' }} size="large" variant="contained" color="secondary" type="submit">
                            {'FİLTRELE'}
                        </Button>
                    </Grid>
                    <Grid item md={3}>
                        <FormControlLabel
                            control={(
                                <Switch
                                    checked={this.state.isComment}
                                    onChange={() => { this.setState({ isComment: !this.state.isComment }); this.props.setFranchiseReportReviewsUpdate().then(() => {}) } }
                                />
                            )}
                            label={"Sadece Yorum Olanlar"}
                        />
                    </Grid>
                    <Grid item md={7}></Grid>
                    <Grid item md={2}>
                        <Button fullWidth style={{ borderRadius: 5, textTransform: 'capitalize', backgroundColor: '#313131' }} onClick={() => this.props.filterReviewsDownload().then(() => { })}>
                            <Icon style={{ marginRight: 10, color: 'white', fontSize: 25 }}>{"cloud_download"}</Icon>
                            {'Excel İndir'}
                        </Button>
                    </Grid>
                </Grid>
                {(isCenterReportLoading ? <div style={{ width: '100%', textAlign: 'center', marginBottom: 15 }}><CircularProgress disableShrink thickness={4} size={40} /></div> : null)}
                <div style={{
                    padding: 10, width: '100%', height: '100%'
                }}
                >
                    <Table className={classNames(classes.table, classes.stripped)}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: '15%' }} align="left">{"Tarih"}</TableCell>
                                <TableCell style={{ width: '10%' }} align="center">{(filterReviews.Type == "GetirYemek" ? "Genel" : "Lezzet")}</TableCell>
                                <TableCell style={{ width: '10%' }} align="center">{(filterReviews.Type == "GetirYemek" ? "-" : "Servis")}</TableCell>
                                <TableCell style={{ width: '10%' }} align="center">{(filterReviews.Type == "GetirYemek" ? "-" : "Teslimat")}</TableCell>
                                <TableCell style={{ width: '100%' }} align="left">{"Yorum"}</TableCell>
                                <TableCell style={{ width: '10%' }} align="right">{"İşlem"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                list.map((n, i) => ([
                                    <TableRow hover key={i}>
                                        <TableCell align="left">{moment(n.date).format('DD.MM.YYYY HH:mm:ss')}</TableCell>
                                        <TableCell style={{ backgroundColor: (n.flavorScore == 1 || n.flavorScore == 2 ? "#c0392b" : (n.flavorScore == 3 ? "#f39c12" : (n.flavorScore == 4 || n.flavorScore == 5 ? "#16a085" : ""))) }} align="center">{n.flavorScore}</TableCell>
                                        <TableCell style={{ backgroundColor: (n.serviceScore == 1 || n.serviceScore == 2 ? "#c0392b" : (n.serviceScore == 3 ? "#f39c12" : (n.serviceScore == 4 || n.serviceScore == 5 ? "#16a085" : ""))) }} align="center">{(filterReviews.Type == "GetirYemek" ? "-" : n.serviceScore)}</TableCell>
                                        <TableCell style={{ backgroundColor: (n.deliveryScore == 1 || n.deliveryScore == 2 ? "#c0392b" : (n.deliveryScore == 3 ? "#f39c12" : (n.deliveryScore == 4 || n.deliveryScore == 5 ? "#16a085" : ""))) }} align="center">{(filterReviews.Type == "GetirYemek" ? "-" : n.deliveryScore)}</TableCell>
                                        <TableCell align="left">{n.comment}</TableCell>
                                        <TableCell align="right" style={{ padding: 5 }}>
                                            <Tooltip title="Adisyon Detayı Görüntüle">
                                                <IconButton
                                                    style={{ padding: 4, backgroundColor: '#3e3e3e', marginRight: 5 }}
                                                    aria-label="Adisyon Detayı Görüntüle"
                                                    id={n.OrderId}
                                                    onClick={this.handleClickPopover}
                                                >
                                                    <Icon>{"receipt_long"}</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ]))
                            }
                        </TableBody>
                    </Table>
                </div>
            </Paper>
        );
    }
}

const valueSelector = (state, props) => state.get('centerBrandReducer').isReviewsUpdate;
const value = createSelector([valueSelector],
    (value) => value);


const mapStateToProps = (state, props) => ({
    isReviewsUpdate: value(state, props),
    franchiseReportName: state.get('centerBrandReducer').franchiseReportName,
    isCenterReportLoading: state.get('centerBrandReducer').isCenterReportLoading,
    filterReviews: state.get('centerBrandReducer').filterReviews,
    franchiseReportReviewsData: state.get('centerBrandReducer').franchiseReportReviewsData,
    centerBrandData: state.get('centerBrandReducer').centerBrandData,
    franchiseReportBrandSelected: state.get('centerBrandReducer').franchiseReportBrandSelected,

    franchiseBrandEntegrationList: state.get('centerBrandReducer').franchiseBrandEntegrationList,
});

const mapDispatchToProps = {
    getReviews,
    setFranchiseReportReviewsFilter,
    setFranchiseReportBrandSelected,
    getEntegrationCacheList,
    getPackageAdditionDetail,
    filterReviewsDownload,
    setFranchiseReportReviewsUpdate
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(injectIntl(Reviews)));
